import { getSafe } from "@jslib/shared/utils/getSafe";

import { includeIPQSDeviceFingerprintScript } from "../IPQS/IPQSutils";
import { collectThreatMetrixProfile } from "../VerificationService/VerificationServiceHelpers";
import { VerificationApiClient } from "../ServerApi/VerificationApiClient";
import { type DatabaseId } from "../types/types";

export const collectDeviceProfile = async (
  verificationId: DatabaseId,
  programId: DatabaseId,
): Promise<void> => {
  const programTheme = await VerificationApiClient.fetchProgramTheme(programId);

  if (getSafe(() => programTheme.threatMetrixEnabled, false)) {
    collectThreatMetrixProfile(verificationId);
  }

  includeIPQSDeviceFingerprintScript(programTheme, verificationId);
};
